import React from 'react'

export default function TermsofServices() {
    return (
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Terms Of Services</h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body fs-5">
                    <h1>Welcome to CoverUP!</h1>
                    <p>These Terms of Service ("Terms") govern your access to and use of the CoverUP website (the "Website") and the services offered thereon (the "Service"). By accessing or using the Website, you agree to be bound by these Terms.</p>

                    <h2>1. Use of the Service</h2>
                    <p>1.1. The Service allows you to create and download cover pages in PDF format by entering your details.</p>
                    <p>1.2. You are granted a non-exclusive, non-transferable license to use the Service for your personal and non-commercial use only.</p>
                    <p>1.3. You are responsible for maintaining the confidentiality of any information you provide while using the Service.</p>
                    <p>1.4. You agree not to use the Service for any illegal or unauthorized purpose. This includes, but is not limited to:</p>
                    <ul>
                        <li>Uploading content that infringes on the intellectual property rights of others.</li>
                        <li>Uploading content that is defamatory, obscene, or hateful.</li>
                        <li>Interfering with the operation of the Service.</li>
                    </ul>

                    <h2>2. User Content</h2>
                    <p>2.1. You retain all ownership rights to the content you create using the Service ("User Content").</p>
                    <p>2.2. By uploading User Content, you grant CoverUP a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, publish, and distribute such User Content solely for the purpose of providing the Service.</p>
                    <p>2.3. You are solely responsible for the accuracy and completeness of your User Content.</p>

                    <h2>3. Disclaimer</h2>
                    <p>3.1. The Service is provided "as is" and without warranties of any kind, express or implied. CoverUP disclaims all warranties, including, but not limited to, the warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>
                    <p>3.2. CoverUP does not warrant that the Service will be uninterrupted, error-free, or secure.</p>

                    <h2>4. Limitation of Liability</h2>
                    <p>4.1. In no event shall CoverUP be liable for any direct, indirect, incidental, special, consequential, or exemplary damages (including, but not limited to, damages for loss of profits, data, or goodwill) arising out of or relating to the use or inability to use the Service, even if CoverUP has been advised of the possibility of such damages.</p>

                    <h2>5. Termination</h2>
                    <p>5.1. CoverUP may terminate your access to the Service at any time, for any reason, without notice.</p>

                    <h2>6. Governing Law</h2>
                    <p>6.1. These Terms shall be governed by and construed in accordance with the laws of India.</p>

                    <h2>7. Entire Agreement</h2>
                    <p>7.1. These Terms constitute the entire agreement between you and CoverUP regarding the use of the Service.</p>

                    <h2>8. Changes to the Terms</h2>
                    <p>8.1. CoverUP may revise these Terms at any time by posting the revised Terms on the Website. You are responsible for checking the Terms periodically. Your continued use of the Service following the posting of revised Terms means that you accept and agree to the changes.</p>

                    <h2>9. Contact Us</h2>
                    <p>9.1. If you have any questions about these Terms, please contact us through <a href="https://www.linkedin.com/in/martinpurification" target="_blank" rel="noopener noreferrer">LinkedIn</a>.</p>

                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Understood</button>
                </div>
            </div>
        </div>
    )
}
